module.exports = __webpack_public_path__ + "static/media/logo@3x.413981c5.png";